/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import OrderSteps from '@/modules/service-point/components/order/order-steps/order-steps.component.vue';

/**
 * Component.
 */
@Component({
  components: { 'order-steps': OrderSteps },
  name: 'deliver-order-status-scene'
})
export default class extends Vue {
  /**
   * Property `servicePointOrderId`.
   */
  @Prop({ default: null, type: String })
  servicePointOrderId: string;

  /**
   * Lifecycle hook created.
   */
  created() {
    if (!this.servicePointOrderId) {
      this.$router.push({
        name: 'ServicePointHome'
      });
    }
  }

  /**
   * Handle go back.
   */
  handleGoback() {
    this.$router.push({
      name: 'ServicePointHome'
    });
  }
}
